import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/css/tailwind.css'
// import JQuery from 'jquery'
// window.$ = JQuery

// console.log(JQuery('body').height()) // => "Hello"


createApp(App).mount('#app')
